import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

const LANGUAGE_LABELS = {
  en: "English",
  hi: "हिन्दी",
  mr: "मराठी",
};

export default function useLanguageMenu() {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const openMenu = useCallback((e) => setAnchorEl(e.currentTarget), []);
  const closeMenu = useCallback(() => setAnchorEl(null), []);

  const changeLanguage = useCallback(
    (lng) => {
      i18n.changeLanguage(lng);
      closeMenu();
    },
    [i18n, closeMenu]
  );

  const currentLanguageLabel = LANGUAGE_LABELS[i18n.language] || i18n.language;

  return {
    anchorEl,
    open,
    openMenu,
    closeMenu,
    changeLanguage,
    currentLanguageLabel,
    t, 
  };
}
